import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inject, observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { SyncStore } from 'src/Stores/Sync/SyncStore';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { ITest } from '../../Interfaces/TestInterface';
import { IWell } from '../../Interfaces/WellInterface';
import ButtonRow from '../ButtonRow';
import { EButton } from '../EInput';
import EmailModal from '../Reporting/EmailModal';


interface IFooter {
    children?: any;
    newTest?: boolean;
    stores?: any;
    test: ITest;
    well: IWell;
    onSave?: any;
    onNavigate?: any;
    saveDisabled?: any;
    hideSave?: boolean;
    history?: any;
    nextLabel?: string;
    saveGrey?: boolean;
    match: any;
}

@inject('stores')
@observer
class Footer extends React.Component {
    public props: IFooter;
    private userStore: UserStore;
    private testsStore: TestsStore;
    private messageStore: MessageStore;
    private SyncStore: SyncStore;

    public state = {
        modal: false,
    };

    constructor(props: any) {
        super(props);
        this.userStore = this.props.stores.UserStore;
        this.testsStore = this.props.stores.TestsStore;
        this.messageStore = this.props.stores.MessageStore;
        this.SyncStore = this.props.stores.SyncStore;
    }

    private toggleModal = () => {
        this.setState({
            modal: !this.state.modal,
        });
    }
    private submitForApproval = (testId: string) => (event: any) => {
        const areYouSure = confirm("Submitting your Mud Test Report will notify a Field Supervisor to review. Are you sure you want to submit?");
        if (areYouSure) {
            this.testsStore.submitForApproval(testId);
        }
    }

    private promptForMudReport = (event: any) => {
        if(this.props.test.testStatus === 'Approved') { 
            const areYouSure = confirm('Before you Print the Report, please check your Mud Test to ensure all inputs were added correctly.\n\n'
                + 'Press Cancel to check your Mud Test OR Press OK to View/Print the Report.');
            if(!areYouSure) {
                event.preventDefault();
            }
        }
    }

    // private finishWellClose = (event: any) => {
    //     const areYouSure = confirm('Are you ready to close the well?\n\nThis will approve the final well test and set the status of the well to closed.\n\nClick Ok to continue.');
    //     if (areYouSure) {
    //         this.wellsStore.closeWell()
    //             .then(data => {
    //                 if (data) {
    //                     this.messageStore.addMessage('Well has been closed.', 'success');
    //                     this.props.history.push('/home');
    //                 }
    //             });
    //     }
    // }

    private approveTest = () => {
        const areYouSure = confirm('Are you ready to approve the test and finalize the Mud Report.\n\nApproving the test will lock inventory.\n\nClick OK to continue.');
        if (areYouSure) {
            const test = this.props.test;
            if (this.props.well && test) {
                test.testStatus = 'Approved';
                this.testsStore.putTest(test, this.props.well.id)
                    .then((data) => {
                        if (data) {
                            this.messageStore.addMessage('Test Approved', 'success');
                        }
                    });
            }
        }
    }

    private createMudReportButton = () => {
        if(this.props.well && this.props.test) {
            if( this.props.test.testStatus !== 'Approved' &&
                (this.userStore.hasPermission('Permissions.WellTests.Approve.All')
                || (
                    this.userStore.hasPermission('Permissions.WellTests.Approve.Assigned')
                    && this.props.well.engineers.some(eng => eng.id === this.userStore.user.id)
                    )
                )
            ) { 
                return <Button color="success" onClick={this.approveTest}>Approve Test</Button>;

            } else {
                switch(this.props.test.testStatus) {
                    case 'Approved':
                        break;
                    case 'Submitted':
                        return <Button className="secondary">Waiting For Approval</Button>;
                    default:
                        return <Button color={this.props.test.testStatus === 'Rejected' ? "warning" : "success"} onClick={this.submitForApproval(this.props.test.id)}>{ this.props.test.testStatus === 'Rejected' ? 'Res' : 'S'}ubmit For Approval</Button>;
                }
            }
        }

        return '';
    }

    private printMudReportButton = () => {
        let buttonText = 'Print Mud Report';
        if(this.props.well && this.props.test) {
            if(this.props.test.testStatus !== 'Approved') { 
                buttonText = 'Preview Mud Report';
            }
            return <Link className="btn btn-primary" style={{marginRight: 10}} to={`/print/well/${this.props.well.id}/test/${this.props.test.id}/mudreportpdf`} target="_blank" onClick={this.promptForMudReport}>{buttonText}</Link>;
        }
        return '';
    }

    private emailMudReportButton = () => {
        if(this.props.well && this.props.test && !this.SyncStore.offline) {
            if(this.props.test.testStatus === 'Approved') {
                return <Button color="primary" type='button' onClick={this.toggleModal}>Email Reports</Button>;
            }
        }
        return '';
    }

    private showVolumeSnapshotButton = () => {
        if (this.props.well && this.props.test && this.props.match.path === "/well/:wellId/test/:taskId/inventory/volumeaccounting")
        {
            return <Link className="secondary btn btn-secondary" style={{marginRight: 10}} target="_blank" to={`/print/well/${this.props.well.id}/test/${this.props.test.id}/volumeaccountsnapshotpdf`} >Snapshot</Link>;
        }
        return false;
    }

    private showProductSnapshotButton = () => {
        if (this.props.well && this.props.test && this.props.match.path === "/well/:wellId/test/:taskId/inventory/products")
        {
            return <Link className="secondary btn btn-secondary" style={{marginRight: 10}} target="_blank" to={`/print/well/${this.props.well.id}/test/${this.props.test.id}/productinventorysnapshotpdf`} >Snapshot</Link>;
        }
        return false;
    }
    // private finishWellCloseButton = () => {
    //     if(this.props.well && this.props.test 
    //         && this.props.well.wellStatus === 'Finishing'
    //         && this.props.test.intervals && this.props.test.intervals[0] 
    //         && this.props.test.intervals[0].intervalType === 'Final') {
    //         if(this.userStore.hasPermission('Permissions.Wells.Close.All') 
    //         || (
    //             this.userStore.hasPermission('Permissions.Wells.Close.Assigned')
    //             && this.props.well.engineers.some(eng => eng.id === this.userStore.user.id)
    //             )
    //         ) {
    //             return <Button type="button" color="danger" style={{marginRight: 10}} onClick={this.finishWellClose}>Close Well</Button>;
    //         }
    //     }
    //     return '';
    // }

    private canSaveWellTest = () => {
        if (this.props.well && this.props.test && this.props.test.id !== '') {
            if(this.userStore.hasPermission('Permissions.WellTests.Update.All') 
            || (
                this.userStore.hasPermission('Permissions.WellTests.Update.Assigned')
                && this.props.well.engineers.some(eng => eng.id === this.userStore.user.id)
                )
            ) {
                return true;
            }
        }
        return false;
    }

    public render() {
        return(
                <ButtonRow>
                    <div>
                        {
                            this.props.well &&
                            <Link className="secondary btn btn-secondary" style={{marginRight: 10}} to={`/well/${this.props.well.id}/details`}>Well Details</Link>
                        }
                        {/* {!this.props.newTest && this.finishWellCloseButton()} */}
                        {!this.props.newTest && this.createMudReportButton()}
                        {!this.props.newTest && this.emailMudReportButton()}
                        {!this.props.newTest && this.printMudReportButton()}
                        { this.props.newTest ? 
                            <React.Fragment>
                                <Button className="secondary" name="cancel" onClick={this.props.onNavigate}>Cancel Test</Button>
                                <EButton color="primary" name="save" disabled={this.props.saveGrey} onClick={this.props.onSave}>{this.testsStore.savingTest ? <FontAwesomeIcon icon={faSpinner} spin={true} /> : 'Save'}</EButton>
                            </React.Fragment>
                        :
                            !this.props.hideSave &&
                            <React.Fragment>
                                <Button className="secondary" name="previous" onClick={this.props.onNavigate}>Previous</Button>
                        {!this.props.saveDisabled && this.canSaveWellTest() && <EButton color="primary" name="save" disabled={this.props.saveGrey} onClick={this.props.onSave}>{this.testsStore.savingTest ? <FontAwesomeIcon icon={faSpinner} spin={true} /> : 'Save'}</EButton> }
                        { this.showVolumeSnapshotButton() }
                        { this.showProductSnapshotButton() }
                                { this.props.children }
                                <Button className="secondary" name="next" onClick={this.props.onNavigate}>{this.props.nextLabel ? this.props.nextLabel : 'Next'}</Button>
                            </React.Fragment>
                        }
                    </div>
                    <div className="footer-content">
                        {this.props.newTest ? (
                            <span>Well: 
                                {this.props.well && this.props.well.wellName} -- {this.props.well && this.props.well.contractor && this.props.well.contractor.contractorName} -- {this.props.well && this.props.well.rigNumber} -- New Test
                            </span>
                        ) : (
                            <span>
                                Well: {this.props.well && this.props.well.wellName} -- {this.props.well && this.props.well.contractor && this.props.well.contractor.contractorName} -- {this.props.well && this.props.well.rigNumber} -- Date: {this.props.test && this.props.well ? `${moment.unix(this.props.test.testDate).tz(this.props.well.timeZoneName).format("MMM DD YYYY, h:mm a")} -- MD: ${this.props.test.depthMD} -- TVD: ${this.props.test.depthTVD} -- Bit Depth: ${this.props.test.depthBit}` : ""}
                            </span>
                        )}
                    </div>
                    {
                        this.props.well && this.props.test && !this.SyncStore.offline &&
                        <EmailModal modalOpen={this.state.modal} toggleModal={this.toggleModal} />
                    }                
                </ButtonRow>
        );
    }
}

export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.tsx